import { ref, onBeforeUnmount } from 'vue';

export function useCountdownTimer() {
    const remaining = ref(0);
    let intervalId = null;

    function start(seconds = 60) {
        stop();
        remaining.value = seconds;
        intervalId = setInterval(() => {
            remaining.value--;
            if (remaining.value <= 0) {
                stop();
            }
        }, 1000);
    }

    function stop() {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
    }

    onBeforeUnmount(() => stop());

    return { remaining, start, stop };
}
